import React from 'react';
import OutboundLink from '../../../atoms/OutboundLink';
import InternalLink from '../../../atoms/InternalLink';
import Event from '../../../darkmatter/Event';

export default ({ internal, slug, body, as, gatsbyLink, style }) => {
  const event = {
    category: 'CTA',
    action: 'click',
    label: 'Card Navigation',
  };
  const linkElementStyle = { width: '100%', height: '100%' };
  const styledBody = <div style={{ width: '100%', textAlign: 'center' }}>{body}</div>;

  if (internal) {
    return (
      <Event event={event} eventType="click">
        <InternalLink
          to={slug}
          as={as}
          gatsbyLink={gatsbyLink}
          style={{ ...linkElementStyle, ...style }}
        >
          {styledBody}
        </InternalLink>
      </Event>
    );
  }
  return (
    <Event event={event} eventType="click">
      <OutboundLink
        to={slug}
        as={as}
        gatsbyLink={gatsbyLink}
        style={{ ...linkElementStyle, ...style }}
      >
        {styledBody}
      </OutboundLink>
    </Event>
  );
};
